import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/dialogue.py DialogueOut.
export interface Dialogue {
  dialogue_id: number;
  name: string;
  description: string;
  script_body: string | null;
  data: string | null;
}

export interface DialogueInput {
  name: string;
  description: string;
  script_body: string | null;
  data: string | null;
}

export async function listDialogues(): Promise<Dialogue[]> {
  const resp = await api.get<APIResponse<Dialogue[]>>("/dialogues/");
  return unwrap(resp.data);
}

export async function createDialogue(body: DialogueInput): Promise<number> {
  const resp = await api.post<APIResponse<{ dialogue_id: number }>>("/dialogues/", body);
  return unwrap(resp.data).dialogue_id;
}

export async function updateDialogue(id: number, body: DialogueInput): Promise<void> {
  await api.put(`/dialogues/${id}`, body);
}

export async function deleteDialogue(id: number): Promise<void> {
  await api.delete(`/dialogues/${id}`);
}
